import React from "react";
import { useMediaQuery } from "react-responsive";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function HeroFlat({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 1100px)" });

  return (
    <div id="heroFlat">
      {isMobile ? (
        <div className="heroFlatMobile">
          <div className="header">{content.header}</div>
          <div className="image">
            <LazyLoadImage src={content.image?.url} alt="heroFlat" effect="blur" />
          </div>
          <div className="description" dangerouslySetInnerHTML={{ __html: content.description }} />
        </div>
      ) : (
        <div className="heroFlatDesktop">
          <div className="heroLeft">
            <div className="image">
              <LazyLoadImage src={content.image?.url} alt="heroFlat" effect="blur" />
            </div>
          </div>
          <div className="heroRight">
            <div className="header">{content.header}</div>
            <div className="description" dangerouslySetInnerHTML={{ __html: content.description }} />
          </div>
        </div>
      )}
    </div>
  );
}
